import { createContext, useContext, useState } from "react";

const initialContext = {
  ver: undefined,
  setVer: () => {},
  editar: undefined,
  setEditar: () => {},
  editandoTexto: false,
  setEditandoTexto: () => {},
  count: 1,
  setCount: () => {},
  draft: true,
  setDraft: () => {},
};

export const GestorAvisosDetallesContext = createContext(initialContext);

export const GestorAvisosContextProvider = ({ children }) => {
  const [count, setCount] = useState(1);
  const [ver, setVer] = useState(undefined);
  const [editar, setEditar] = useState(undefined);
  const [editandoTexto, setEditandoTexto] = useState();
  const [draft, setDraft] = useState(true);

  return (
    <GestorAvisosDetallesContext.Provider
      value={{
        ver,
        setVer,
        editar,
        setEditar,
        editandoTexto,
        setEditandoTexto,
        count,
        setCount,
        draft,
        setDraft,
      }}
    >
      {children}
    </GestorAvisosDetallesContext.Provider>
  );
};

export const useGestorAvisosDetalles = () => {
  return useContext(GestorAvisosDetallesContext);
};
